import { CircularProgress, Grid } from "@mui/material";
import React from "react";
import { PageLoaderWrapper } from "./styled";

export default function PageLoader() {
  return (
    <PageLoaderWrapper>
      <Grid
        container
        direction="row"
        justifyContent="center"
        alignItems="center"
        style={{ height: "100%" }}
      >
        <Grid item>
          <CircularProgress />
        </Grid>
      </Grid>
    </PageLoaderWrapper>
  );
}
